import React, { useCallback, useEffect, useState } from "react";
import style from "./returns.module.scss";
import { Table } from "react-bootstrap";
import { useDispatch } from "react-redux";
import { LinearLoader } from "../../components/Loader/LinearLoader";
import Pagination from "../../components/paginationCopy/Pagination";
import Search from "../../components/search";
import { loadVendors } from "../../redux/admin/actions/admin.actions";
import { EyeOutlined } from "@ant-design/icons";
import { SortButton } from "../../components/utils/sortButton";
import axiosClient from "../../service/axios";
import InitiatedDetails from "../../components/modalInstruction/InitiatedDetails";

const Returns = () => {
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(true);
  const [data, setData] = useState([]);
  const [returns, setReturns] = useState([]);

  const [search, setSearch] = useState("");
  const [details, setDetails] = useState(false);
  const [rowDetails, setRowDetails] = useState(null);

  useEffect(() => {
    setLoading(true);
    dispatch(loadVendors());
    setLoading(false);
  }, [dispatch]);

  const handleView = (orderid, product, date) => {
    console.log(product);
    setDetails(true);
    setRowDetails({ orderid, product, date });
  };

  useEffect(() => {
    const fetchReturns = async () => {
      try {
        const response = await axiosClient.get("/lite/v2/api/admin/return");
        setReturns(response.data);
      } catch (error) {
        console.log(error);
      }
    };
    fetchReturns();
  }, []);

  // Search handler
  useEffect(() => {
    setData(
      returns?.filter((id) => {
        return Object.values(id).some((name) =>
          String(name).toLowerCase().includes(search.toLowerCase())
        );
      })
    );
  }, [returns, search]);

  const handleChange = (e) => {
    setSearch(e.target.value);
  };

  // pagination
  const [pageNumber, setPageNumber] = useState(0);
  const size = 10;
  const pagesVisited = pageNumber * size;
  const pageCount = Math.ceil(data?.length / size);

  const changePage = ({ selected }) => {
    setPageNumber(selected);
  };

  // sorting
  const [sortKey, setSortKey] = useState("contact_name");
  const [sortOrder, setSortOrder] = useState("desc");

  const sortedData = useCallback(() => {
    function sortData({ tableData, sortKey, reverse }) {
      if (!sortKey) return tableData;

      const sortedData = data.sort((a, b) => {
        return a[sortKey] > b[sortKey] ? 1 : -1;
      });

      if (reverse) {
        return sortedData.reverse();
      }

      return sortedData;
    }
    return sortData({
      tableData: data,
      sortKey,
      reverse: sortOrder === "desc",
    });
  }, [data, sortKey, sortOrder]);

  const headers = [
    { key: "index", label: "S/N" },
    { key: "product", label: "Product" },
    { key: "hospital_name", label: "Hospital Name" },
    { key: "phone", label: "Phone Number" },
    { key: "date", label: "Date" },
  ];

  const changeSort = (key) => {
    setSortOrder(sortOrder === "ascn" ? "desc" : "ascn");
    setSortKey(key);
  };

  return (
    <>
      <div className="d-flex justify-content-between m-3">
        <div></div>
        <Search placeholder="Find a vendor" onChange={handleChange} />
      </div>
      <section style={{ maxWidth: "95%", margin: "auto" }}>
        {loading && <LinearLoader />}
        <Table borderless responsive className="mt-4">
          <thead>
            <tr className={style.TableHeadRow}>
              {headers.map((row) => {
                return (
                  <td key={row.key}>
                    {row.label}{" "}
                    <SortButton
                      columnKey={row.key}
                      onClick={() => changeSort(row.key)}
                      {...{ sortOrder, sortKey }}
                    />
                  </td>
                );
              })}
            </tr>
          </thead>
          {data?.length > 0 ? (
            <tbody>
              {sortedData()
                ?.slice(pagesVisited, pagesVisited + size)
                ?.map((vend, index) => (
                  <tr className={style.tableBodyRow} key={index}>
                    <td>{vend?.id}</td>
                    <td style={{ cursor: "pointer" }}>{vend?.product}</td>
                    <td style={{}}>
                      {vend?.hospital ? vend?.hospital : "N/A"}
                    </td>
                    <td style={{}}>{vend?.phone ? vend?.phone : "N/A"}</td>

                    <td style={{}}>{vend?.created}</td>

                    <td className="d-flex gap-4 justify-content-center align-items-center">
                      <EyeOutlined
                        className={style.action}
                        style={{ color: "gray", fontSize: "19px" }}
                        onClick={() =>
                          handleView(
                            vend?.orderid,
                            vend?.product,
                            vend?.created
                          )
                        }
                      />{" "}
                    </td>
                  </tr>
                ))}
            </tbody>
          ) : (
            <div className="d-flex justify-content-center align-items-center">
              No Request to return
            </div>
          )}
        </Table>
        {data?.length > size && (
          <Pagination pageCount={pageCount} onPageChange={changePage} />
        )}
      </section>

      <InitiatedDetails
        details={details}
        setDetails={setDetails}
        props={rowDetails}
      />
    </>
  );
};

export default Returns;
